const config = {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
    API_PY_URL: process.env.REACT_APP_API_PY_URL
};
/** Its values are read from .env.development when we run npm run for dev
 * its values are read from .env.production when we run npm build from Docker file
 */
export default config;
